import {
  Button,
  ReferenceInput,
  SelectInput,
  TextInput,
  useNotify,
  useRefresh,
  ArrayInput,
  SimpleFormIterator,
  useSimpleFormIteratorItem,
  AutocompleteInput,
  required,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import { accountRequests } from "api/accountApi";
import { AddressTypeChoices } from "utils/choices";

import { administrationRequests } from "api/administrationApi";
import { BULGARIA_COUNTRY_ID } from "utils/constants";
import { useFormContext, useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import dataProvider from "server/dataProvider";

const EditAddressInfoModal = ({ record, data }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);

  const handleSubmit = async formData => {
    const cleanedAddresses = formData.addresses.map(addr => {
      if (addr.countryId !== BULGARIA_COUNTRY_ID) {
        const { settlementId, ...rest } = addr;
        return rest;
      }
      return addr;
    });
    await dataProvider.customRequest(
      accountRequests.getUserAddresses(record?.userId),
      { addresses: cleanedAddresses },
      "PUT",
    );
    refresh();
    notify("Успешна редакция на адрес", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Редакция адреси"
      onConfirm={handleSubmit}
      confirmEnabled={isConfirmEnabled}
      defaultValues={{ addresses: data || [] }}
      triggerButton={
        <Button
          label="Редакция адреси"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <FormContent setIsConfirmEnabled={setIsConfirmEnabled} />
    </FormModal>
  );
};

const FormContent = ({ setIsConfirmEnabled }) => {
  const {
    formState: { isDirty: formDirty },
  } = useFormContext();

  const adresses = useWatch({
    name: "addresses",
  });
  useEffect(() => {
    setIsConfirmEnabled(formDirty);
  }, [formDirty, setIsConfirmEnabled]);

  const canAdd = (adresses?.length || 0) < 2;
  const canRemove = (adresses?.length || 0) > 1;

  return (
    <Grid
      container
      spacing={2}
      gap={4}
      pt={4}
    >
      <ArrayInput
        source="addresses"
        label={false}
      >
        <SimpleFormIterator
          disableAdd={!canAdd}
          disableRemove={!canRemove}
          disableClear
        >
          <Grid
            container
            spacing={2}
          >
            <AddressTypeField adresses={adresses} />
            <Grid
              item
              xs={12}
              md={6}
            >
              <ReferenceInput
                source="countryId"
                reference={administrationRequests.getCountriesSelect()}
              >
                <AutocompleteInput
                  filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  optionText="nameBg"
                  label="Държава"
                  validate={required()}
                />
              </ReferenceInput>
            </Grid>
            <SettlementField />
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextInput
                source="address"
                label="Адрес"
                validate={required()}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
            >
              <TextInput
                source="postalCode"
                label="Пощенски код"
                validate={required()}
              />
            </Grid>
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </Grid>
  );
};
const AddressTypeField = ({ adresses }) => {
  const { index } = useSimpleFormIteratorItem();

  return (
    <Grid
      item
      xs={12}
      md={6}
    >
      <SelectInput
        source="type"
        label="Тип адрес"
        choices={AddressTypeChoices}
        validate={value => validateUniqueAddressType(value, adresses, index)}
      />
    </Grid>
  );
};

const SettlementField = () => {
  const { index } = useSimpleFormIteratorItem();

  const countryId = useWatch({
    name: `addresses.${index}.countryId`,
  });

  if (countryId !== BULGARIA_COUNTRY_ID) return null;

  return (
    <Grid
      item
      xs={12}
      md={6}
    >
      <ReferenceInput
        source="settlementId"
        reference={administrationRequests.getSettlementsSelect()}
      >
        <AutocompleteInput
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          optionText="nameBg"
          label="Град"
          validate={required()}
        />
      </ReferenceInput>
    </Grid>
  );
};
const validateUniqueAddressType = (typeId, allAddresses, currentIndex) => {
  if (!typeId) {
    return "Задължително ";
  }

  const duplicateIndex = allAddresses?.findIndex((addr, idx) => idx !== currentIndex && addr?.type === typeId);

  if (duplicateIndex !== -1) {
    return `Този тип адрес вече е избран на ред ${duplicateIndex + 1}`;
  }
  return undefined;
};
export default EditAddressInfoModal;
